import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '../../components/Button';
import FgiModal from '../../components/FgiModal';
import Markdown from '../../components/Markdown';
import { useGlobalState } from '../../hooks';

export const ELearningModal = ({
  show,
  onHide,
  goToCourse,
  eLearningItems,
}) => {
  const [{ locale }] = useGlobalState();
  const [t] = useTranslation();

  return (
    <FgiModal
      onHide={onHide}
      show={show}
      color="blue"
      title={t('E-Learning')}
      description={t('Wobei dürfen wir Sie unterstützen?')}
    >
      <div className="modal-list-container">
        {eLearningItems.map((item) => (
          <div key={item.id} className="modal-list-container-item">
            <div className="modal-list-container-item-title title-article">
              {item.title?.[locale]}
            </div>
            <div className="modal-list-container-item-description description">
              <Markdown>{item.description?.[locale]}</Markdown>
            </div>
            <Button
              onClick={goToCourse(
                item.course_id?.[locale],
                item.title?.[locale],
              )}
              size="medium"
              variant="secondary"
            >
              {t('Wählen')}
            </Button>
          </div>
        ))}
      </div>
    </FgiModal>
  );
};

ELearningModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  goToCourse: PropTypes.func.isRequired,
};

export default ELearningModal;
